import { formatCDSDevicesToAdaptedDevices } from '../utils/device-formatter.js';

/**
 * @typedef {import('../types/message-strategy').PickerMessageStrategy} PickerMessageStrategy
 */

/**
 * @type {PickerMessageStrategy}
 */
export const pickerDeviceAddedStrategy = {
  handleMessage: (data, currentDevices, totalCount) => {
    const newDevices = [...currentDevices, formatCDSDevicesToAdaptedDevices([data.device])[0]];
    const newTotalCount = totalCount + 1;

    return { newDevices, newTotalCount };
  },
};

/**
 * @type {PickerMessageStrategy}
 */
export const pickerDeviceDeletedStrategy = {
  handleMessage: (data, currentDevices, totalCount) => {
    const newDevices = currentDevices.filter(recentDevice => recentDevice.id !== data.device.id);
    const newTotalCount = totalCount - 1;

    return { newDevices, newTotalCount };
  },
};

/**
 * @type {PickerMessageStrategy}
 */
export const pickerDeviceUpdatedStrategy = {
  handleMessage: (data, currentDevices, totalCount) => {
    const newDevices = currentDevices.map(device => {
      if (device.id === data.device.id) {
        return formatCDSDevicesToAdaptedDevices([data.device])[0];
      }

      return device;
    });

    return { newDevices, newTotalCount: totalCount };
  },
};
